import script from "./SelectApi.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectApi.vue?vue&type=script&setup=true&lang=js"

import "./SelectApi.vue?vue&type=style&index=0&id=4956e06a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4956e06a"]])

export default __exports__